import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

function SplashPage() {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [codeError, setCodeError] = useState('');
  const [showNotify, setShowNotify] = useState(false);
  const [notifyForm, setNotifyForm] = useState({
    firstName: '', lastName: '', email: ''
  });
  const [notifyError, setNotifyError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  function handleCodeSubmit() {
    if (code.trim().toLowerCase() === 'iamsomebody') {
      localStorage.setItem('sg_access', 'iamsomebody');
      navigate('/');
      window.location.reload();
    } else {
      setCodeError('That code is not recognized. Try again or sign up to be notified when we launch.');
    }
  }

  async function handleNotifySubmit() {
    if (!notifyForm.firstName || !notifyForm.email) {
      setNotifyError('Please enter your first name and email.');
      return;
    }

    try {
      setSubmitting(true);
      setNotifyError('');

      await addDoc(collection(db, 'waitlist'), {
        firstName: notifyForm.firstName,
        lastName: notifyForm.lastName,
        email: notifyForm.email,
        createdAt: serverTimestamp(),
        source: 'splash'
      });

      navigate('/waitlist-confirm');
    } catch (err) {
      console.error('Error adding to waitlist:', err);
      setNotifyError('Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  }

  const s = {
    page: {
      minHeight: '100vh',
      background: '#f7faf8',
      fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, sans-serif',
      color: '#16231d',
      display: 'flex',
      flexDirection: 'column'
    },
    header: {
      padding: '1.25rem 2rem',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid #e7eee9',
      background: 'rgba(255,255,255,0.9)',
      position: 'sticky',
      top: 0,
      zIndex: 10
    },
    logo: {
      fontSize: '1.25rem',
      fontWeight: 800,
      color: '#1e3a5f',
      letterSpacing: '-0.03em'
    },
    orgLink: {
      fontSize: '0.9rem',
      color: '#2d6a4f',
      textDecoration: 'none',
      cursor: 'pointer',
      fontWeight: 700
    },
    main: {
      flex: 1,
      padding: '4rem 2rem 3rem',
      display: 'flex',
      justifyContent: 'center'
    },
    shell: {
      width: '100%',
      maxWidth: '1120px',
      display: 'grid',
      gridTemplateColumns: '1.1fr 0.9fr',
      gap: '3rem',
      alignItems: 'center'
    },
    left: {
      maxWidth: '620px'
    },
    eyebrow: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.4rem',
      background: '#eaf4ef',
      color: '#2d6a4f',
      border: '1px solid #cfe6d9',
      borderRadius: '999px',
      padding: '0.4rem 0.8rem',
      fontSize: '0.82rem',
      fontWeight: 800,
      marginBottom: '1.25rem'
    },
    headline: {
      fontSize: '3.3rem',
      lineHeight: 1.03,
      letterSpacing: '-0.055em',
      fontWeight: 850,
      color: '#101827',
      marginBottom: '1rem'
    },
    subhead: {
      fontSize: '1.15rem',
      lineHeight: 1.65,
      color: '#4b5563',
      maxWidth: '570px',
      marginBottom: '1.5rem'
    },
    proofRow: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '0.75rem',
      margin: '1.75rem 0'
    },
    proofCard: {
      background: 'white',
      border: '1px solid #e5e7eb',
      borderRadius: '14px',
      padding: '1rem',
      boxShadow: '0 8px 24px rgba(15, 23, 42, 0.05)'
    },
    proofTitle: {
      fontSize: '0.82rem',
      color: '#2d6a4f',
      fontWeight: 800,
      marginBottom: '0.25rem'
    },
    proofText: {
      fontSize: '0.9rem',
      color: '#4b5563',
      lineHeight: 1.4
    },
    quote: {
      borderLeft: '4px solid #2d6a4f',
      paddingLeft: '1rem',
      color: '#374151',
      fontSize: '1rem',
      lineHeight: 1.6,
      marginTop: '1.5rem'
    },
    panel: {
      background: 'white',
      border: '1px solid #e5e7eb',
      borderRadius: '22px',
      padding: '1.5rem',
      boxShadow: '0 20px 60px rgba(15, 23, 42, 0.10)'
    },
    panelHeader: {
      marginBottom: '1.25rem'
    },
    panelTitle: {
      fontSize: '1.35rem',
      fontWeight: 800,
      color: '#101827',
      marginBottom: '0.35rem'
    },
    panelSub: {
      fontSize: '0.95rem',
      color: '#6b7280',
      lineHeight: 1.5
    },
    card: {
      background: '#f9fafb',
      border: '1px solid #e5e7eb',
      borderRadius: '16px',
      padding: '1.25rem',
      marginBottom: '1rem'
    },
    cardTitle: {
      fontSize: '1rem',
      fontWeight: 800,
      marginBottom: '0.35rem',
      color: '#111827'
    },
    cardSub: {
      fontSize: '0.86rem',
      color: '#6b7280',
      marginBottom: '1rem',
      lineHeight: 1.45
    },
    input: {
      width: '100%',
      padding: '0.8rem 0.95rem',
      border: '1.5px solid #d1d5db',
      borderRadius: '10px',
      fontSize: '1rem',
      marginBottom: '0.75rem',
      boxSizing: 'border-box',
      fontFamily: 'inherit',
      background: 'white'
    },
    btnPrimary: {
      width: '100%',
      background: '#1e3a5f',
      color: 'white',
      border: 'none',
      padding: '0.9rem',
      borderRadius: '10px',
      fontSize: '1rem',
      fontWeight: 800,
      cursor: 'pointer'
    },
    btnSecondary: {
      width: '100%',
      background: '#2d6a4f',
      color: 'white',
      border: 'none',
      padding: '0.9rem',
      borderRadius: '10px',
      fontSize: '1rem',
      fontWeight: 800,
      cursor: 'pointer'
    },
    error: {
      background: '#fee2e2',
      color: '#991b1b',
      padding: '0.7rem 0.875rem',
      borderRadius: '10px',
      fontSize: '0.875rem',
      marginBottom: '0.75rem',
      textAlign: 'left'
    },
    divider: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem',
      margin: '1rem 0',
      color: '#9ca3af',
      fontSize: '0.82rem'
    },
    line: {
      flex: 1,
      height: '1px',
      background: '#e5e7eb'
    },
    footer: {
      padding: '1.5rem 2rem',
      textAlign: 'center',
      fontSize: '0.8rem',
      color: '#6b7280'
    },
    mobileStyle: `
      @media (max-width: 850px) {
        .splash-shell {
          grid-template-columns: 1fr !important;
          gap: 1.5rem !important;
        }
        .splash-main {
          padding: 2rem 1rem !important;
        }
        .splash-headline {
          font-size: 2.25rem !important;
        }
        .splash-proof-row {
          grid-template-columns: 1fr !important;
        }
        .splash-header {
          padding: 1rem !important;
        }
      }
    `
  };

  return (
    <div style={s.page}>
      <style>{s.mobileStyle}</style>

      <header style={s.header} className="splash-header">
        <div style={s.logo}>somebody.gives</div>
        <a href="/org" style={s.orgLink}>For nonprofits →</a>
      </header>

      <main style={s.main} className="splash-main">
        <div style={s.shell} className="splash-shell">

          <section style={s.left}>
            <div style={s.eyebrow}>📍 Springfield, MO · private preview</div>

            <h1 style={s.headline} className="splash-headline">
              Cover a real need for a Springfield nonprofit — every month.
            </h1>

            <p style={s.subhead}>
              Choose a real need - like socks, diapers, or detergent - 
              and cover it each month.
              Most commitments are $15-$30 and make a huge impact.
            </p>

            <div style={s.proofRow} className="splash-proof-row">
              <div style={s.proofCard}>
                <div style={s.proofTitle}>Specific</div>
                <div style={s.proofText}>You pick exactly what you're providing - not just "donate and hope."</div>
              </div>

              <div style={s.proofCard}>
                <div style={s.proofTitle}>Recurring</div>
                <div style={s.proofText}>Common items can be fulfilled automatically on schedule.</div>
              </div>

              <div style={s.proofCard}>
                <div style={s.proofTitle}>Local</div>
                <div style={s.proofText}>Built first for Springfield nonprofits and donors.</div>
              </div>
            </div>

            <div style={s.quote}>
              Everybody knew the need. Anybody could have helped.
              Nobody was responsible. So nothing changed.
              <br />
              <strong>Until somebody took responsibility.</strong>
            </div>
          </section>

          <aside style={s.panel}>
            <div style={s.panelHeader}>
              <div style={s.panelTitle}>Private preview</div>
              <div style={s.panelSub}>
                We are testing with a small group of Springfield organizations
                before opening publicly.
              </div>
            </div>

            <div style={s.card}>
              <div style={s.cardTitle}>Have an access code?</div>
              <div style={s.cardSub}>
                Enter your beta access code to explore the platform.
              </div>

              {codeError && <div style={s.error}>{codeError}</div>}

              <input
                style={s.input}
                placeholder="Enter access code"
                value={code}
                onChange={e => setCode(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && handleCodeSubmit()}
              />

              <button style={s.btnPrimary} onClick={handleCodeSubmit}>
                Enter preview →
              </button>
            </div>

            <div style={s.divider}>
              <div style={s.line} />
              <span>or</span>
              <div style={s.line} />
            </div>

            <div style={s.card}>
              <div style={s.cardTitle}>Would you do this?</div>
              <div style={s.cardSub}>
                If this were live today, would you commit to covering one or more local needs each month?
                No obligation - just gauging interest.
              </div>

              {!showNotify ? (
                <button
                  style={s.btnSecondary}
                  onClick={() => setShowNotify(true)}
                >
                  Yes - Notify me when it’s ready →
                </button>
              ) : (
                <>
                  {notifyError && <div style={s.error}>{notifyError}</div>}

                  <input
                    style={s.input}
                    placeholder="First name"
                    value={notifyForm.firstName}
                    onChange={e => setNotifyForm(
                      prev => ({ ...prev, firstName: e.target.value })
                    )}
                  />

                  <input
                    style={s.input}
                    placeholder="Last name (optional)"
                    value={notifyForm.lastName}
                    onChange={e => setNotifyForm(
                      prev => ({ ...prev, lastName: e.target.value })
                    )}
                  />

                  <input
                    style={s.input}
                    placeholder="Email address"
                    type="email"
                    value={notifyForm.email}
                    onChange={e => setNotifyForm(
                      prev => ({ ...prev, email: e.target.value })
                    )}
                  />

                  <button
                    style={s.btnSecondary}
                    onClick={handleNotifySubmit}
                    disabled={submitting}
                  >
                    {submitting ? 'Saving...' : 'Notify me →'}
                  </button>
                </>
              )}
            </div>
          </aside>

        </div>
      </main>

      <footer style={s.footer}>
        somebody.gives — Springfield, MO — more communities coming soon
      </footer>
    </div>
  );
}

export default SplashPage;